import { useDispatch, useSelector } from "react-redux";
import { removeFromCart, increaseQuantity, decreaseQuantity } from "../../store/cartSlice";
import { Link } from "react-router-dom";

const CartPage = () => {
    const cart = useSelector(state => state.cart);
    const dispatch = useDispatch();

    const subtotal = cart?.items?.reduce((acc, item) => acc + item.price * item.quantity, 0) || 0;
    const taxes = (subtotal * 0.13).toFixed(2);
    const shipping = cart?.items?.length > 0 ? 10.00 : 0.00;
    const total = (subtotal + parseFloat(taxes) + shipping).toFixed(2);

    const handleRemove = (productId) => {
        dispatch(removeFromCart({ productId }));
    };

    const handleIncrease = (productId) => {
        dispatch(increaseQuantity({ productId }));
    };

    const handleDecrease = (productId, quantity) => {
        if (quantity > 1) {
            dispatch(decreaseQuantity({ productId }));
        } else {
            // Remove the item from the cart if quantity reaches 0
            handleRemove(productId);
        }
    };

    return (
        <div className="container mx-auto p-6">
            {cart?.items?.length === 0 ? (
                <div className="text-center">
                    <h2 className="text-2xl font-bold mb-4">Your Cart is Empty</h2>
                    <p className="mb-4">It seems you haven't added anything to your cart yet.</p>
                    <Link to="/" className="mt-4 inline-block bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-all duration-300">
                        Go to Homepage
                    </Link>
                </div>
            ) : (
                <>
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-2 text-left">Image</th>
                                    <th className="px-4 py-2 text-left">Name</th>
                                    <th className="px-4 py-2 text-left">Price</th>
                                    <th className="px-4 py-2 text-left">Quantity</th>
                                    <th className="px-4 py-2 text-left">Total</th>
                                    <th className="px-4 py-2 text-left">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cart?.items?.map((item) => (
                                    <tr key={item.productId} className="border-b">
                                        <td className="px-4 py-2">
                                            <img src={item.cover} alt={item.title} className="w-16 h-16 object-cover" />
                                        </td>
                                        <td className="px-4 py-2">{item.title}</td>
                                        <td className="px-4 py-2">${item.price.toFixed(2)}</td>
                                        <td className="px-4 py-2">
                                            <div className="flex items-center">
                                                <button
                                                    onClick={() => handleDecrease(item.productId, item.quantity)}
                                                    className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
                                                >
                                                    -
                                                </button>
                                                <span className="px-4">{item.quantity}</span>
                                                <button
                                                    onClick={() => handleIncrease(item.productId)}
                                                    className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
                                                >
                                                    +
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-4 py-2">${(item.price * item.quantity).toFixed(2)}</td>
                                        <td className="px-4 py-2">
                                            <button
                                                className="text-red-500 hover:text-red-700"
                                                onClick={() => handleRemove(item.productId)}
                                            >
                                                Remove
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="mt-6 bg-gray-50 p-4 rounded-lg shadow-md">
                        <p className="text-lg font-semibold">Subtotal: <span className="font-normal">${subtotal.toFixed(2)}</span></p>
                        <p className="text-lg font-semibold">Taxes (13%): <span className="font-normal">${taxes}</span></p>
                        <p className="text-lg font-semibold">Shipping: <span className="font-normal">${shipping.toFixed(2)}</span></p>
                        <p className="text-lg font-semibold">Total: <span className="font-normal">${total}</span></p>
                    </div>
                    <Link to="/cart/checkout" className="mt-6 inline-block bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-700 transition-all duration-300">
                        Proceed to Checkout
                    </Link>
                </>
            )}
        </div>
    );
};

export default CartPage;
